export const axiosError = (error) => {
    alert(error.response.data.message)
    console.log(error)
}